import React from "react";
import PropTypes from "prop-types";
import { Radio, styled, Grid, Typography } from "@mui/material";
import { PALETTE } from "../../Theme/Palette";

const BpIcon = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  width: 24,
  height: 24,
  backgroundColor: PALETTE.primary,
  backgroundImage: PALETTE.primary,
  border: "1px solid " + PALETTE.fourth,
  ".Mui-focusVisible &": {
    outline: "2px auto " + PALETTE.fourth,
    outlineOffset: 2,
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5",
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: PALETTE.fifth,
    border: "1px solid transparent",
  },
  "input:checked ~ &": {
    border: "1px solid transparent",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "linear-gradient(180deg, #FFFFFF 0%, #D4D9E7 100%)",
  backgroundImage: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
  // background : '#d94075' ,
  // background : '#d13c70' ,
  // background : '#c3285df5' ,
  // background: "linear-gradient(54.23deg, #e73573 1.96%, #ed4b82 99.68%)",
  "&:before": {
    width: 16,
    height: 16,
    borderRadius: "50%",
    backgroundColor: PALETTE.primary,
    content: '""',
  },
  "input:hover ~ &": {
    background: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
  },
  "input:disabled ~ &": {
    background: "linear-gradient(54.23deg, #E8447D 1.96%, #FB83AC 99.68%)",
  },
});

function BaseRadio({ text, value, isLong, containerStyle, ...props }) {
  return (
    <Grid
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      ml={1}
      width={isLong ? "500px" : "auto"}
      {...containerStyle}
    >
      <Typography variant="h2" textAlign="right" fontSize="14px">
        {text}
      </Typography>
      <Radio
        sx={{
          "&:hover": {
            bgcolor: "transparent",
          },
          fontSize: "14px",
        }}
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        inputProps={{ "aria-label": "A" }}
        value={value}
        {...props}
      />
    </Grid>
  );
}

BaseRadio.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  isLong: PropTypes.bool,
};

export default BaseRadio;
